module.exports = __webpack_public_path__ + "static/img/banber (3).bd5785c8.png";